<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Ações</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button @click.prevent="fillAllLines()" class="btn-dark btn-block">
            Preencher Palavras
          </d-button>
          <d-button
            @click.prevent="cleanAllLines()"
            class="btn-danger btn-block mt-2"
          >
            Limpar Jogo
          </d-button>
          <print-buttons :cryptogramName="model.name" />
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer
    class="border-top d-flex flex-column flex-xl-row justify-content-around"
  >
    <d-button
      @click="save"
      type="button"
      class="btn-primary mb-3 mb-xl-0 col-xl-5"
    >
      Salvar
    </d-button>
    <d-button class="btn-secondary text-white col-xl-5" @click="goBack">Voltar</d-button>
  </d-card-footer>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import PrintButtons from './PrintButtons.vue';
import {
  _CRYPTOGRAM_FILL_ALL_LINES_,
  _CRYPTOGRAM_CLEAR_ALL_ANSWERS_,
  MODEL,
} from './CryptogramModel';

export default {
  name: 'sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  components: { PrintButtons },
  methods: {
    ...mapActions(['setToggle']),
    fillAllLines() {
      Events.$emit(_CRYPTOGRAM_FILL_ALL_LINES_);
    },
    cleanAllLines() {
      Events.$emit(_CRYPTOGRAM_CLEAR_ALL_ANSWERS_);
    },
    goBack() {
      this.$router.go(-1);
    },
    save() {
      this.$emit('save', this.model);
    },
  },
};
</script>
